// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"69":"64e987c1","315":"d43b3bfc"}[chunkId] + ".css";
};